import { render } from "./SocialLinks.vue?vue&type=template&id=9c8ccdfa&scoped=true"
const script = {}

import "./SocialLinks.vue?vue&type=style&index=0&id=9c8ccdfa&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8ccdfa"]])

export default __exports__